import { IMonHocUpdateCongThucRequest } from "../../model/request/category/IMonHocUpdateCongThucRequest"
import { IMonHoc } from "../../model/response/category/IMonHoc"
import { apiClient } from "../apiClient"

export const MON_HOC_API = "mon-hoc"
export const monHocApi = {
    SelectAll: () => apiClient.get(`${MON_HOC_API}`),
    Insert: (payload: IMonHoc) => apiClient.post(MON_HOC_API, payload),
    Update: (payload: IMonHoc) => apiClient.put(MON_HOC_API),
    Delete: (id: number) => apiClient.delete(MON_HOC_API),
    UpdateCongThucMon: (id_mon: number, payload: IMonHocUpdateCongThucRequest) => apiClient.patch(`${MON_HOC_API}/${id_mon}/cong-thuc`, payload),
    ReadAndValidateImportCongThuc: (payload: any) => apiClient.post(`${MON_HOC_API}/import/read-and-validate-cong-thuc`, payload),
    ImportCongThuc: (payload: any) => apiClient.post(`${MON_HOC_API}/import`, payload),
}